import * as Sentry from "@sentry/browser";
import { sentryIgnoreErrors } from '/frontend/app/modules/logging/constants';

const {
  environment, release, sentryEnabledEnvironmentsSetting, sentryFrontendV2DsnSetting, domain,
} = window.railsVariables;

const domainRegexp = new RegExp(`https?://${domain.replace(/[/\-\\^$*+?.()|[\]{}]/g, "\\$&")}`);

if (sentryEnabledEnvironmentsSetting.includes(environment)) {
  Sentry.init({
    dsn: sentryFrontendV2DsnSetting,
    tunnel: "https://sentry.siepomaga.pl/tunnel", // Cloudflare Worker
    environment,
    release,
    sendDefaultPii: true,

    ignoreErrors: sentryIgnoreErrors,

    allowUrls: [
      domainRegexp,
    ],

    beforeSend(event) {
      // enhance event with user email
      const enhancedEvent = {
        ...event,
        user: {
          ...event.user,
          id: document.querySelector("meta[name='sentry-user:id']")?.content,
          email: document.querySelector("meta[name='sentry-user:email']")?.content,
          ip_address: document.querySelector("meta[name='sentry-user:ip_address']")?.content,
        },
      };

      return enhancedEvent;
    },

    beforeBreadcrumb(breadcrumb) {
      const ignoredUrls = [
        /analytics\.google\.com/,
        /google-analytics\.com/,
        /\/statystyki/,
      ];

      // Do not log fetch/xhr requests to ignoredUrls
      if (breadcrumb.category === "xhr" || breadcrumb.category === "fetch") {
        if (ignoredUrls.some((regex) => regex.test(breadcrumb.data?.url))) {
          return null;
        }
      }

      return breadcrumb;
    },

    integrations: [
      Sentry.browserTracingIntegration({
        // Do not create spans for outgoing requests to stats endpoints
        shouldCreateSpanForRequest: (url) => !/\/statystyki\/?$/.test(url),
      }),

      Sentry.extraErrorDataIntegration(),
      Sentry.httpClientIntegration(),
      Sentry.contextLinesIntegration(),
    ],
  });
}
